export { default as ToggleSwitch } from './ToggleSwitch'
export type { ToggleSwitchProps } from './types'
